import 'css-chunksrc/client/common/layout/projectHistory/searchResults/styles.scss';export default {
  "searchResults": "_searchResults_dchpd_1",
  "result": "_result_dchpd_5",
  "icon": "_icon_dchpd_18",
  "match": "_match_dchpd_27",
  "flag": "_flag_dchpd_32"
};